import { useMemo } from "react";
import { useSelector } from "react-redux";
import { FeatureDc } from "@evergis/api";

import { getReferenceLayerInfos } from "../../../ducks/showFeature/selectors";
import { getLayerInfoFromDataSources } from "../utils/getLayerInfoFromDataSources";
import { getFeatureAttributes } from "../utils/getFeatureAttributes";
import { ConfigContainer, ConfigContainerChild } from "../types";
import { FeatureDataSource } from "../../../ducks/showFeature/types";
import { LayerInfo } from "../../../interfaces/resourceInfo";

export const useRelatedDataSourceAttributes = ({
  config,
  elementConfig,
  dataSources,
  feature,
}: {
  config: ConfigContainer;
  elementConfig: ConfigContainerChild;
  dataSources: FeatureDataSource[];
  feature?: FeatureDc;
}) => {
  const layerInfos = useSelector(getReferenceLayerInfos);

  const { options } = elementConfig || {};
  const { relatedDataSource } = options || {};

  const dataSource = useMemo(
    () => dataSources?.find(({ name }) => name === relatedDataSource),
    [dataSources, relatedDataSource],
  );

  const layerInfo = useMemo(
    () =>
      getLayerInfoFromDataSources(layerInfos, config?.dataSources, relatedDataSource) ||
      ({ layerDefinition: { attributes: dataSource?.attributeDefinition || {} } } as LayerInfo),
    [config?.dataSources, dataSource?.attributeDefinition, layerInfos, relatedDataSource],
  );

  const attributes = useMemo(
    () => getFeatureAttributes(feature, layerInfo, dataSource),
    [dataSource, feature, layerInfo],
  );

  return { layerInfo, attributes, dataSource };
};
